import Comparison from '../components/Comparison';
export default function PricingPage() { return <Comparison />; }
